import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
const HeroSection = () => {
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-6 py-3">
                        <h1>Empower Your Campus With Datacode</h1>
                        <p>Join student leaders, faculty, and tech enthusiasts in hosting inspiring events that transform how your campus learns and grows. Datacode brings five years of community expertise directly to your institution.</p>
                        <div>
                            <CustomButton className="mb-sm-2">Explore</CustomButton>
                            <CustomButton className="bg-light text-dark border ml-4">Connect</CustomButton>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <img
                            src={img2}
                            alt="Community Event"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
